export default "__VITE_ASSET__zTZcGGW5__"